module.exports = __webpack_public_path__ + "img/home_thirteen.9e4573bf.png";